const el = {
  tooltipContainer: document.querySelector<HTMLDivElement>('.product-info__trade-in-example-tooltip__trigger-element'),
  customTooltip: document.querySelector<HTMLDivElement>('.product-info__trade-in-example-tooltip--customTooltip'),
}

export const ProductTooltip = {
  init: () => {
    if (!el.tooltipContainer || !el.customTooltip) return

    el.tooltipContainer.addEventListener('mouseenter', function() {
      // Get the position of the parent container relative to the viewport
      const containerRect = el.tooltipContainer.getBoundingClientRect();

      // Position the custom tooltip above the container
      el.customTooltip.textContent = el.tooltipContainer.dataset.title;
      
      el.customTooltip.style.left = `0px`; // Align left with the container
      el.customTooltip.style.bottom = `${containerRect.height}px`; // Position above the container, with some spacing
  
      // Make the tooltip visible
      el.customTooltip.style.visibility = 'visible';
      el.customTooltip.style.opacity = "1";
    });
  
    el.tooltipContainer.addEventListener('mouseleave', function() {
    // Hide the custom tooltip when the mouse leaves the container
    el.customTooltip.style.visibility = 'hidden';
    el.customTooltip.style.opacity = "0";
  });
  },

}
